
export const API_URL = {
  AUTH: {
    LOGIN: '/login',
    SIGN_UP: 'users/register',
    REFRESH_TOKEN: 'users/tokens/refresh_token',
    ACCOUNT_INFO: 'player/account',
    API_CONFIG: 'config',
    LIST_PAYMENT: 'payment',
    CREATE_PAYMENT: 'payment/create',
    REFRESH_PAYMENT: 'payment/refresh',
    CREATE_PAYOUT: 'payout/create',
  },
  GAME: {
    GET_HISTORY: 'game',
    GET_DETAIL_HISTORY: 'game/:gameId',
    GET_SETTING: 'schema/:gameCode',
    SUBMIT_BET: 'player/bet',
    SUBMIT_BET_BATCH: 'player/bet_batch',
    GET_BET_HISTORY: 'player/bet',
    GET_BET_JOINED: 'taixiu/live'
  },
  SETTING_LAYOUT: {
    GET_SEAT: 'seats',
  },
  ORDER: {
    CREATE_ORDER: 'orders',
    ORDER_HISTORIES: 'orders',
    APPROVE_ORDER: 'orders/approve',
    REJECT_ORDER: 'orders/reject',
  },
  TICKET: {
    CHECK_IN: 'tickets/check-in'
  }
}

export const TICKET_ENUM = {
  DAY_1: 'melody_day_1',
  DAY_2: 'melody_day_2'
}

export const TICKET_NAME = {
  [TICKET_ENUM.DAY_1]: 'Melody show 1/5 - Hoài Niệm',
  [TICKET_ENUM.DAY_2]: 'Melody show 2/5 - Thăng Hoa' 
}

export const TICKET_START_TIME = {
  [TICKET_ENUM.DAY_1]: '01/05/2025',
  [TICKET_ENUM.DAY_2]: '02/05/2025' 
}
export const SEAT_STATUS = {
  NOT_AVAILABLE: 0,
  AVAILABLE: 1,
}

export const ORDER_STATUS= {
  WAITING_PAYMENT: 0, // chờ thanh toán
  COMPLETED: 1, // đã thanh toán
  CANCELLED: 2, // thanh toán thất bại
}

// export const TICKET_STATUS = {
//   AVAILABLE: 0,
//   CHECKIN: 1,
// }

export const TICKET_ADDRESS = {
  [TICKET_ENUM.DAY_1]: 'Ninh Bình',
  [TICKET_ENUM.DAY_2]: 'Ninh Bình' 
}


export const TICKET_STATUS = {
  CREATED: 0,
  APPROVE: 1,
  REJECT: 2,
}
export const TICKET_STATUS_NAME = {
  [TICKET_STATUS.CREATED]: 'Đang chờ duyệt',
  [TICKET_STATUS.APPROVE]: 'Đã duyệt',
  [TICKET_STATUS.REJECT]: 'Đã hủy',
}


export const BASE_URL = process.env.REACT_APP_HOST
